import {Detail} from './Detail';

export class WriteResult extends Detail {
  fileName: string;
}
